import ActionText from '../ActionText';
import TitledPanel from '../TitledPanel';
import SecondaryButton from '../SecondaryButton';
import PrimaryButton from '../PrimaryButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeCancelable } from '../utils/utils';
import GS from '../../grafsync/grafsync';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';

class DetailedStatisticsDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRegion: undefined,
            triples: [],
            history: [],
            diskspace: [],
            regions: []
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.getStatistics();
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    doGetStatistics(statistic) {
        this.cancellable = makeCancelable(GS.getDetailedStatistics(this.props.subscription, statistic));
        return this.cancellable;
    }

    getStatistics = async () => {
        try {
            const triples = await this.doGetStatistics("triple-count").promise;
            if (this.cancellable && this.cancellable.isCancelled()) return;
            const history = await this.doGetStatistics("history-count").promise;
            if (this.cancellable && this.cancellable.isCancelled()) return;
            const diskspace = await this.doGetStatistics("diskspace-count").promise;
            if (this.cancellable && this.cancellable.isCancelled()) return;
            const regions = [...new Set(triples.map(i => i.region))];
            const selectedRegion = regions.length > 0 ? regions[0] : undefined;
            this.setState({ triples, history, regions, diskspace, selectedRegion });
        }
        catch (e) {
            if (this.cancellable && this.cancellable.isCancelled()) return;
            this.setState({ selectedRegion: undefined });
        }
    };

    exitStatistics = () => this.props.onCancel();

    selectRegion = (selectedRegion) => this.setState({ selectedRegion });

    render() {

        const { classes, title } = this.props;
        const { triples, history, diskspace, regions, selectedRegion } = this.state;

        return (
            <React.Fragment>
                <Dialog className={classes.dialog}
                    open={true}
                    maxWidth="sm"
                    fullWidth
                    onClose={this.exitUpdateSubscription} aria-labelledby="statistics-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="statistics-dialog-title">{title}</DialogTitle>
                    <DialogContent>
                        <div style={{ marginBottom: 24 }}>
                            {regions.map(region => {
                                return <span style={{ marginRight: 24 }} key={region}>
                                    <SecondaryButton
                                        dataTest="select-region"
                                        onClick={() => this.selectRegion(region)}>{region}</SecondaryButton>
                                </span>;
                            })}
                        </div>
                        {selectedRegion ?
                            <TitledPanel
                                height="full"
                                dataTest="subscription-statistics"
                                fontSize="large"
                                title={"Detail for Region: " + selectedRegion}>
                                <div style={{ height: 300, overflowY: 'scroll' }}>
                                    <Table>
                                        <TableHead style={{ backgroundColor: '#e8e8e8' }}>
                                            <TableRow>
                                                <TableCell component="th" className={classes.tableHeading}>Date</TableCell>
                                                <TableCell component="th" className={classes.tableHeading} align="right">Triples</TableCell>
                                                <TableCell component="th" className={classes.tableHeading} align="right">Changes in<br />Last 24 Hours</TableCell>
                                                <TableCell component="th" className={classes.tableHeading} align="right">Free<br/>Disk</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody style={{ backgroundColor: 'white' }}>
                                            {triples.filter(d => d.region === selectedRegion).map((i, index) => {
                                                const date = new Date(i.date);
                                                const historyItem = history.find(h => h.date === i.date && i.region === selectedRegion);
                                                const historyCount = historyItem ? historyItem.value : "N/A";
                                                const diskspaceItem = diskspace.find(h => h.date === i.date && i.region === selectedRegion);
                                                const diskspaceCount = diskspaceItem ? Math.floor(diskspaceItem.value / 1073741824) + "GB" : "N/A";
                                                return <TableRow data-test={"stats-row-" + index} key={index}>
                                                    <TableCell data-test="stat-date" component="td" className={classes.tableCell}>{date.toLocaleString()}</TableCell>
                                                    <TableCell data-test="stat-count" component="td" className={classes.tableCell} align={"right"}>{i.value}</TableCell>
                                                    <TableCell data-test="history-count" component="td" className={classes.tableCell} align={"right"}>{historyCount}</TableCell>
                                                    <TableCell data-test="diskspace-count" component="td" className={classes.tableCell} align={"right"}>{diskspaceCount}</TableCell>
                                                </TableRow>;
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                            </TitledPanel>
                            :
                            <ActionText offset="40px">No region available.</ActionText>
                        }
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <PrimaryButton onClick={this.exitStatistics}>Close</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

DetailedStatisticsDialog.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    subscription: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default withStyles(styles)(DetailedStatisticsDialog);